export const DATE_PICKER_YEAR_DROPDOWN_ID = 'date-picker-year-dropdown'
